import React from 'react';
import { ContractTypeId } from '@block-explorer/entities';
import Avatar, { AvatarProps } from '../avatar/avatar';

export interface ContractIconProps {
  src?: string | null;
  size?: AvatarProps['size'];
  loading?: boolean;
  contractTypeId: number | undefined | null;
}

const ContractIconsPath = {
  [ContractTypeId.Cep18]: 'assets/icons/ic-cep18-contract-icon.svg',
  [ContractTypeId.CustomCep18]: 'assets/icons/ic-cep18-contract-icon.svg',
  [ContractTypeId.CEP47Nft]: 'assets/icons/ic-nft-contract-icon.svg',
  [ContractTypeId.CustomCEP47Nft]: 'assets/icons/ic-nft-contract-icon.svg',
  [ContractTypeId.CEP78Nft]: 'assets/icons/ic-nft-contract-icon.svg',
  [ContractTypeId.CustomCEP78Nft]: 'assets/icons/ic-nft-contract-icon.svg',
  [ContractTypeId.DeFi]: 'assets/icons/ic-defi-contract-icon.svg',
};

const genericIconPath = 'assets/icons/ic-generic-contract-icon.svg';

export const ContractIcon = ({
  src,
  size = 'default',
  loading,
  contractTypeId,
}: ContractIconProps) => {
  const contractTypeDefaultLogo = contractTypeId
    ? ContractIconsPath[contractTypeId]
    : null;
  const contractLogoSrc = contractTypeDefaultLogo || genericIconPath;

  if (src) {
    return (
      <Avatar size={size} src={src} loading={loading} alt={'Contract logo'} />
    );
  }
  return <Avatar size={size} path={contractLogoSrc} loading={loading} />;
};

export default ContractIcon;
